import { ArrowRightIcon, LockKeyIcon } from "@phosphor-icons/react";
import { type FormEvent, useState } from "react";

import { ApiError } from "../api/client";
import { useAuth } from "../auth/AuthProvider";
import { Button } from "../components/Button";
import { TextField } from "../components/Field";
import { Navigate, useLocation } from "../router";

export function LoginPage() {
  const { user, login } = useAuth();
  const location = useLocation();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  if (user) {
    const destination =
      (location.state as { from?: string } | null)?.from ?? "/";
    return <Navigate replace to={destination} />;
  }

  async function submit(event: FormEvent) {
    event.preventDefault();
    setSubmitting(true);
    setError("");
    try {
      await login(username, password);
    } catch (reason) {
      setError(
        reason instanceof ApiError ? reason.message : "Не удалось войти",
      );
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <main className="login-page">
      <section className="login-intro">
        <div className="brand brand--login">
          <span className="brand__mark">U</span>
          <div>
            <strong>Unicore</strong>
            <span>Command Center</span>
          </div>
        </div>
        <div className="login-intro__copy">
          <span className="eyebrow">Внутренняя платформа</span>
          <h1>Контент, языки и публикации — в одном рабочем контуре.</h1>
          <p>
            Управляйте новым сайтом без изменения кода. Все действия
            версионируются и остаются в журнале.
          </p>
        </div>
        <span className="login-intro__index">01 / CONTROL</span>
      </section>

      <section className="login-form-panel">
        <form className="login-form" onSubmit={submit}>
          <span className="login-form__icon">
            <LockKeyIcon size={22} />
          </span>
          <div>
            <h2>Вход для команды</h2>
            <p>Используйте административную учётную запись Unicore.</p>
          </div>
          <TextField
            autoComplete="username"
            label="Логин"
            onChange={(event) => setUsername(event.target.value)}
            placeholder="username"
            required
            value={username}
          />
          <TextField
            autoComplete="current-password"
            error={error}
            label="Пароль"
            onChange={(event) => setPassword(event.target.value)}
            placeholder="Не менее 12 символов"
            required
            type="password"
            value={password}
          />
          <Button disabled={submitting} type="submit">
            {submitting ? "Проверяем доступ" : "Продолжить"}
            <ArrowRightIcon size={18} />
          </Button>
        </form>
      </section>
    </main>
  );
}
